/**
 * Please follow the below steps to use this control
 *
 * In Component
 *  step 1: Import "PaginationControlsForStaticTemplateComponent" component and declare a variable before constructor.
 *      config = PaginationControlsForStaticTemplateComponent.getDefaultConfig();
 *
 *  step 2: declare how many pages you need in your tempalte ex 2,3 etc...
 *      ngOnInit() {
 *        this.config.totalItems = 2;
 *     }
 *
 * In HTML
 *  step 1: use pagination nc-pagination-controls-for-static-template in your tempalte.
 *       <ul class="touch-pagination">
 *       <div nc-pagination-controls-for-static-template [config]="config"></div>
 *       </ul>
 *
 *  step 2: Based on how many pages you need and on which page what you want to display split the page using ng-contianer.
 *      <ng-container *ngIf="config.currentPage == 1">
 *        your first page content
 *      </ng-container>
 *
 *      <ng-container *ngIf="config.currentPage == 2">
 *        your second page content
 *      </ng-container>
 *
 * That's it, reload the applciation you will be seeing the paging controls in your page.
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPaginationControlsComponent } from 'shared.root/models/pagination.component.interface';
import { PaginationInstanceModel } from 'shared.root/models/pagination-instance.model';

@Component({
  selector: '[nc-pagination-controls-for-static-template]',
  templateUrl: './pagination-controls-for-static-template.component.html',
  standalone: false,
})
export class PaginationControlsForStaticTemplateComponent implements IPaginationControlsComponent, OnInit {
  inputObjectForPagination: Array<unknown> = [];
  static getDefaultConfig(): PaginationInstanceModel {
    return new PaginationInstanceModel('pagingControls', 1, 1, 2);
  }

  @Input() config: PaginationInstanceModel;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit(): void {
    this.prepareInputObjectForPagination();
  }

  pageChanged(newPageNumber: number): void {
    this.config.currentPage = newPageNumber;
    this.pageChange.emit(newPageNumber);
  }

  trackItem(index: number, __: unknown): number {
    return index;
  }

  /**
   * Based on user's input it will create a object with as many items as asked by user via totalItems proeprty.
   * for example if user want to display 3 pages then 3 items will be pushed in the mockObjectForPagination array.
   */
  private prepareInputObjectForPagination(): void {
    if (this.config.totalItems > 0) {
      for (let i = 0; i < this.config.totalItems; i++) {
        this.inputObjectForPagination.push({ dummyValue: i });
      }
    }
  }
}
